import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";

/**
 * Shown after a successful PATCH on /account/me. The magic link has been
 * spent so we cannot re-show the form. We confirm + redirect to home.
 */
export default function AccountUpdatedPage() {
  const [params] = useSearchParams();
  const emailChanged = params.get("email_changed") === "1";

  return (
    <div className="bg-white min-h-screen">
      <section className="bg-[var(--dark-bg)] grain-dark py-20 md:py-28 relative overflow-hidden">
        <div
          aria-hidden="true"
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-[var(--lime)]/15 blur-3xl pointer-events-none"
        />
        <div className="container-main max-w-xl text-center relative z-10">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[var(--lime)] mb-7 animate-[bounceIn_500ms_ease-out]">
            <Check size={40} strokeWidth={3} className="text-[var(--dark-bg)]" />
          </div>
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[var(--lime)] mb-4">
            <span className="w-6 h-px bg-[var(--lime)]" />
            All set
          </span>
          <h1 className="font-['Outfit'] font-bold text-white text-4xl md:text-5xl leading-[1.05] mb-5">
            Your details are
            <span className="text-[var(--lime)]"> up to date.</span>
          </h1>
          <p className="text-lg text-white/80 leading-relaxed max-w-md mx-auto mb-10">
            Thanks for keeping your information current. We'll only get in
            touch when a study matches your profile.
            {emailChanged && (
              <>
                {" "}A confirmation has been sent to your previous email
                address as a safety measure.
              </>
            )}
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[var(--lime)] text-[var(--dark-bg)] font-semibold text-sm hover:bg-[var(--lime-dark)] transition-all"
          >
            <ArrowLeft size={16} />
            Back to home
          </Link>
        </div>
      </section>
      <style>{`
        @keyframes bounceIn {
          0%   { transform: scale(0); opacity: 0; }
          60%  { transform: scale(1.15); opacity: 1; }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
